import { render, staticRenderFns } from "./PowerIncreaseChart.vue?vue&type=template&id=9a60d944&"
import script from "./PowerIncreaseChart.vue?vue&type=script&lang=js&"
export * from "./PowerIncreaseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports